// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Y2_z","title":"Header_title__2WRrD","left":"Header_left__1yOXg","clinicName":"Header_clinicName__1gNGC"};